import type { ReactNode } from "react";
import { useBuilderStore } from "../Hooks/useBuilderStore";
import { useSetCssVars } from "../Hooks/useSetCssVars";
import { useSystemAppearance } from "../Hooks/useSystemAppearance";
import type { Appearance } from "../Store/interfaceSlice";

interface ThemeManagerProps {
  children: ReactNode;
  shouldListenToSystemAppearance?: boolean;
}

export const ThemeManager = ({
  children,
  shouldListenToSystemAppearance = false,
}: ThemeManagerProps) => {
  const appearance = useBuilderStore(state => state.appearance);
  const toggleAppearance = useBuilderStore(state => state.toggleAppearance);
  const currentCanvasTheme = useBuilderStore(state => state.currentCanvasTheme);

  useSystemAppearance({
    onAppearanceChange: (newAppearance: Appearance) => {
      if (shouldListenToSystemAppearance) {
        toggleAppearance(newAppearance);
      }
    },
    isEnabled: shouldListenToSystemAppearance,
  });

  useSetCssVars({ themes: currentCanvasTheme.cssVariables, appearance });

  return <>{children}</>;
};
